module.exports = __webpack_public_path__ + "img/9-3.df9feca6.png";